import { LitElement, html, svg } from 'lit';

export class IconEdit16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Blyant</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.34 1.66a2.264 2.264 0 0 0-3.217.022l-9.022 9.022L1 15l4.296-1.102 9.022-9.022a2.264 2.264 0 0 0 .022-3.216v0Z"></path></svg>`; }
}
if (!customElements.get('f-icon-edit16', IconEdit16)) {
  customElements.define('f-icon-edit16', IconEdit16);
}